<template>
  <div class="key-container">
    <div class="keyboard" @click.stop="handleKeyPress">
      <div class="key-row">
        <div class="cell-box">
          <div class="key-cell" data-num="7">7</div>
        </div>
        <div class="cell-box">
          <div class="key-cell" data-num="8">8</div>
        </div>
        <div class="cell-box">
          <div class="key-cell" data-num="9">9</div>
        </div>
        <div class="cell-box">
          <div class="key-cell" data-num></div>
        </div>
      </div>
      <div class="key-row">
        <div class="cell-box">
          <div class="key-cell" data-num="4">4</div>
        </div>
        <div class="cell-box">
          <div class="key-cell" data-num="5">5</div>
        </div>
        <div class="cell-box">
          <div class="key-cell" data-num="6">6</div>
        </div>
        <div class="cell-box">
          <div class="key-cell" data-num></div>
        </div>
      </div>
      <div class="key-row">
        <div class="cell-box">
          <div class="key-cell" data-num="1">1</div>
        </div>
        <div class="cell-box">
          <div class="key-cell" data-num="2">2</div>
        </div>
        <div class="cell-box">
          <div class="key-cell" data-num="3">3</div>
        </div>
        <div class="cell-box">
          <div class="key-cell" data-num></div>
        </div>
      </div>
      <div class="key-row">
        <div class="cell-box">
          <div class="key-cell" data-num=".">.</div>
        </div>
        <div class="cell-box">
          <div class="key-cell" data-num="0">0</div>
        </div>
        <div class="cell-box">
          <div class="key-cell key-delete" data-num="D">删除</div>
        </div>
        <div class="cell-box">
          <div class="key-cell" data-num></div>
        </div>
      </div>
      <div class="key-right-clear">
        <div class="key-clear" data-num="C">清空</div>
      </div>
      <div class="key-right-confirm">
        <div class="key-confirm" data-num="S">确认</div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.key-container {
  width: 100%;
  height: 3.8rem;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  color: rgba(51, 51, 51, 0.85);

}
.keyboard {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  padding: 0.05rem;
  background: rgba(240, 240, 240);
  box-sizing: border-box;
}
.key-row {
  display: flex;
  display: -webkit-flex;
  position: relative;
  line-height: 1rem;

}
</style>
<script>
export default {
  data() {
    return {
      num: "",
      click: null
    };
  },
  props: ["fatherNum", "clickTime"],
  mounted() {
    this.num = this.fatherNum;
  },
  methods: {
    // 处理按键
    handleKeyPress(e) {
      const num = e.target.dataset.num;
      // 不同的按键处理逻辑
      // num为空，直接返回
      if (!num) return;
      switch (String(num)) {
          // 删除键
        case "D":
          this.handleDeleteKey();
          break;
          // 清空键
        case "C":
          this.handleClearKey();
          break;
          // 确认键
        case "S":
          this.handleConfirmKey();
          break;
        default:
          this.handleNumberKey(num);
          break;
      }
    },
    // 处理删除键
    handleDeleteKey() {
      this.num = this.fatherNum; // 这一步是为了让this.num能及时接收this.fatherNum的值，解决第二行输入后去删除第一行值出现的bug
      const S = this.num;
      if (!S) return false;
      if (!S.length) return false;// 如果没有输入（或者长度为0），直接返回
      // 否则删除最后一个
      this.num = S.substring(0, S.length - 1);
      this.$emit("deleteEvent", this.num); //把删除处理后了的值返回给父组件
    },
    // 处理清空键
    handleClearKey() {
      this.num = ""; // 清空就赋值一个‘’，然后返回给父组件
      this.$emit("clearEvent", this.num);
    },
    // 处理数字
    handleNumberKey(num) {
      // 确保处理的this.num是父组件传入的this.fatherNum
      this.num = this.fatherNum;
      this.click = this.clickTime;
      const S = this.num; // 拿到父组件点击的那个输入框的值
      //   第一次不能输入.
      if (this.click == 1) {
        if (num == ".") return;
      }
      //前提是并非刚点击了input
      if (this.click != 1) {
        // 若this.num有且只有一位数并且是0，则输入的不是.，就返回
        if (S && S.length == 1 && S[0] == 0 && num != ".") return;
        if (S) {
          let index = S.indexOf(".");
          // 如果存在.，则不能再次输入.
          if (index > -1 && num == ".") return;
          //   小数位数不能超过2位
          if (S && index > -1 && S.length - 2 > index) return;
        }
      }
      if (!S) {
        //如果是首次输入，则原有的this.num是undefined,不需要拼接上
        this.num = `${num}`;
      } else {
        this.num = `${S}${num}`; // 在原有的基础上将点击的那个数字按键的数字加在原有数字字符串末尾，此处是为删除提供数据
      }
      //   此处不能使用正则表达式判断

      this.$emit("numberEvent", num); // 注意传的是点击的那个数字字符串，不是处理后的整个数字字符串
    },
    // 确认键
    handleConfirmKey() {
      // 这一步是为了解决一进页面，input框内有值，直接点确认出现数据情况，再次点数据出现undefined问题(如果没有该赋值，this.num为undefined)
      this.num = this.fatherNum;
      const S = this.num;
      // 如果输入的数字最后一位是.，则删除
      if (S) {
        let index = S.indexOf(".");
        if (index == S.length - 1) {
          this.num = S.substring(0, S.length - 1);
        }
      }
      this.$emit("confirmEvent", this.num);
    }
  }
};
</script>



// WEBPACK FOOTER //
// NumKeypad.vue?98ed203c